<template>
  <footer class="f-foot">
    <div class="f-wrap">
      <div class="f-foot-top">
        <div class="f-foot-brand">
          <brandF tone="dark" />
          <p class="tag">{{ $t('f_footer_tag') }}</p>
          <div class="f-lbl">{{ $t('f_pay_with') }}</div>
          <div class="chips">
            <i v-for="name in channelList" :key="name">{{ name }}</i>
          </div>
        </div>

        <div class="f-foot-col">
          <h4>{{ $t('legal') }}</h4>
          <a href="javascript:;" @click="jump('conduct')">Rules of Conduct</a>
          <a href="javascript:;" @click="jump('tos')">Terms of service</a>
          <a href="javascript:;" @click="jump('privacy')">Privacy policy</a>
        </div>

        <div class="f-foot-col">
          <h4>{{ $t('contact_us') }}</h4>
          <a v-if="email" :href="'mailto:' + email">{{ email }}</a>
          <span v-if="phone">{{ phone }}</span>
          <span class="addr" v-if="address">{{ address }}</span>
        </div>
      </div>

      <!-- 底部超大字标，只做装饰 -->
      <div class="f-foot-giant" aria-hidden="true">{{ siteName }}</div>

      <div class="f-copy">
        <span>{{ copyRight }}</span>
        <span>{{ region }} · ⚡ 24/7</span>
      </div>
    </div>
  </footer>
</template>

<script>
import env from '../assets/js/env'
import brandF from './components/brandF.vue'

const CHANNELS = {
  IDR: ['QRIS', 'DANA', 'OVO', 'SHOPEEPAY', 'LINKAJA', 'ASTRAPAY', 'BCA', 'BNI', 'BRI', 'CIMB', 'MANDIRI', 'PERMATA', 'ALFAMART', 'CREDIT'],
  THB: ['BAY', 'BBL', 'CREDIT', 'KBANK', 'KTB', 'LINEPAY', 'PROMPTPAY', 'SCB', 'SHOPEE', 'TRUEMONEY'],
  PHP: ['7ELEVEN', 'BPI', 'CEBUANA', 'GCASH', 'GRABPAY', 'PAYMAYA', 'SHOPEE', 'CREDIT', 'UBP'],
  BRL: ['AME', 'BANK TRANSFER', 'BOLETO', 'MERCADO PAGO', 'PAYPAL', 'PICPAY', 'PIX'],
  MXN: ['BANK TRANSFER', 'OXXO', 'PAYCASH'],
  VND: ['WOORI', 'MOMO', 'VIETTELPAY', 'VNPTPAY', 'SHOPEE', 'APPOTA', 'ZALOPAY'],
  MYR: ['TNG', 'MCASH', 'BOOST', 'GRABPAY', 'FPX', 'UNIONPAY'],
}

export default {
  components: { brandF },
  data() {
    return {
      siteName: env.siteName || env.brand || env.brandName,
      email: env.email,
      phone: env.phone,
      address: env.address,
      copyRight: env.copyRight,
      currency: this.$store.state.orderInfo.gameCurrency,
    }
  },
  computed: {
    channelList() {
      return CHANNELS[this.currency || 'IDR'] || CHANNELS.IDR
    },
    region() {
      return this.currency || 'IDR'
    },
  },
  methods: {
    jump(path) {
      this.$router.push({ path: `/${path}` })
    },
  },
}
</script>
